import React, { useState, useContext, Dispatch, SetStateAction } from 'react';
import { Row, Typography, Button, Modal, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { FaCaretDown } from 'react-icons/fa';
import classnames from 'classnames';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import { GlobalModalProps } from '../../orders/PlaceOrder';
import { RestrictionContext } from '../../dashboard/components/Restrictions';
import { CategoryList } from './Categories';
// import Categories from '../../../constants/productcategory';

export interface CategoryItemsProps {
  item: string;
  color: string;
  checked: boolean;
  onChange: (e: CheckboxChangeEvent) => void;
}

export interface CategorgyModalProps {
  category: string[];
  setCategory?: Dispatch<SetStateAction<string[]>>;
}

export const CategoryItems: React.FC<CategoryItemsProps> = ({
  item,
  color,
  checked,
  onChange,
}) => {
  return (
    <div className="filter-content-items">
      <div className="filter-content-title" style={{ color }}>
        <span>{i18n.t(item)}</span>
      </div>
      <Checkbox checked={checked} onChange={onChange} />
    </div>
  );
};

export const CategoryModalContent: React.FC<CategorgyModalProps> = ({
  category,
  setCategory,
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string[]>(category);

  const handleChecboxChange = (item: string) => (e: CheckboxChangeEvent) => {
    if (selectedCategory.includes(item)) {
      setSelectedCategory(selectedCategory.filter(i => i !== item));
    } else {
      setSelectedCategory(selectedCategory.concat(item));
    }
  };

  const onPressSave = () => {
    if (category && category !== selectedCategory) {
      category.length = 0;
      category.push(...selectedCategory);
      setCategory && setCategory(selectedCategory);
    }
    Modal.destroyAll();
  };
  return (
    <div className="modal-content-wrapper">
      <Typography.Title level={4}>{i18n.t('Category')}</Typography.Title>
      <div className="meal-category-container">
        {CategoryList.map(list => {
          return list.category.map((item, i) => (
            <CategoryItems
              key={i}
              item={item}
              color={list.color}
              checked={selectedCategory.includes(item)}
              onChange={handleChecboxChange(item)}
            />
          ));
        })}
      </div>
      <div className="button-container filter-button">
        <Button
          block
          type="primary"
          shape="round"
          className="continue-button continue-button-primary"
          onClick={onPressSave}
        >
          <span className="continue-button-text">{i18n.t('Save')}</span>
        </Button>
      </div>
    </div>
  );
};

export const Category: React.FC = () => {
  const { category, setCategory } = useContext(RestrictionContext);
  const { t } = useTranslation();

  const selectCategory = () => {
    Modal.info({
      ...GlobalModalProps,
      centered: true,
      content: (
        <CategoryModalContent category={category} setCategory={setCategory} />
      ),
    });
  };

  const listClassname = classnames({
    'filter-selected-container': category.length !== 0,
  });
  return (
    <React.Fragment>
      <Row className="restrictions-wrapper">
        <Typography.Text className="filter-menu-title">
          {t('Category')}
        </Typography.Text>
        <Button
          shape="round"
          className="filter-buttons filter-restrictions-menu"
          onClick={selectCategory}
        >
          {t('Select')} <FaCaretDown />
        </Button>
      </Row>
      <Row className={listClassname}>
        {category &&
          category.map((item, i) => {
            const find = CategoryList.find(c => c.category.includes(item));
            const color = find && find.color;
            return (
              <div key={i} className="filter-selected-items">
                <span style={{ color }}>{t(item)}</span>
              </div>
            );
          })}
      </Row>
    </React.Fragment>
  );
};
